import { CTASectionTypes } from '../homePage';

export namespace StorageTipsTypes {
  export interface IStorageTips {
    title: string;
    tipsList: string[];
    categories: TCategoryConfig[];
    showAccordion: boolean;
    accordionConfig?: TAccordionConfig;
    CTASection?: CTASectionTypes.ICTASection;
    theme?: 'light' | 'dark';
  }

  export type TCategoryConfig = {
    title: string;
    content: string[];
  };

  export type TAccordionConfig = {
    contentArr?: TAccordionContentConfig[];
    faqArr?: TContent[];
    icons?: {
      openingIcon: TIconType;
      closingIcon: TIconType;
      openingIconDesktop: TIconDesktopType;
      closingIconDesktop: TIconDesktopType;
    };
    theme?: 'light' | 'dark';
    section?: string;
  };

  export type TAccordionContentConfig = {
    title?: string;
    content?: string[];
  };

  export type TContent = {
    answer: string;
    id: string;
    question: string;
    show_in_compact_mode?: boolean;
  };

  export type TIconType = 'tfw-add-circle-cp' | 'tfw-minus-cirlce-cp';
  export type TIconDesktopType =
    | 'tfw-add-circle-bold-cp'
    | 'tfw-minus-cirlce-bold-cp';
}
